import { Modal, Button } from 'react-bootstrap';

// Reusable confirm modal for destructive / important actions.
export default function ConfirmDialog({
  show, title = 'Please confirm', message, confirmText = 'Confirm', cancelText = 'Cancel',
  variant = 'danger', onConfirm, onCancel, busy = false,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton><Modal.Title style={{ fontSize: '1rem' }}>{title}</Modal.Title></Modal.Header>
      <Modal.Body><div className="hrms-muted">{message}</div></Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onCancel} disabled={busy}>{cancelText}</Button>
        <Button variant={variant} onClick={onConfirm} disabled={busy}>{busy ? 'Working…' : confirmText}</Button>
      </Modal.Footer>
    </Modal>
  );
}
